"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ListBucketMetricsConfigurationsInput_1 = require("./ListBucketMetricsConfigurationsInput");
var ListBucketMetricsConfigurationsOutput_1 = require("./ListBucketMetricsConfigurationsOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.ListBucketMetricsConfigurations = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "ListBucketMetricsConfigurations",
    http: {
        method: "GET",
        requestUri: "/{Bucket}?metrics"
    },
    input: {
        shape: ListBucketMetricsConfigurationsInput_1.ListBucketMetricsConfigurationsInput
    },
    output: {
        shape: ListBucketMetricsConfigurationsOutput_1.ListBucketMetricsConfigurationsOutput
    },
    errors: []
};
//# sourceMappingURL=ListBucketMetricsConfigurations.js.map